const INSPECTION_TYPE = {
  brkey: "",
  createDate: null,
  dueDate: null,
  endDate: null,
  equipA01: "0",
  equipA02: "0",
  equipA03: "0",
  equipA04: "0",
  equipA05: "0",
  equipA06: "0",
  equipA07: "0",
  equipA08: "0",
  equipA09: "0",
  equipA10: "0",
  equipA11: "0",
  equipA12: "0",
  equipA13: "0",
  equipA14: "0",
  equipAN: "0",
  equipAX: "0",
  equipConcat: null,
  equipIN: "0",
  equipI01: "0",
  equipI02: "0",
  equipI03: "0",
  equipI04: "0",
  equipI05: "0",
  equipI06: "0",
  equipI07: "0",
  equipI08: "0",
  equipI09: "0",
  equipI10: "0",
  equipI11: "0",
  equipI12: "0",
  equipI13: "0",
  equipI14: "0",
  equipI15: "0",
  equipIX: "0",
  inspInterval: null,
  inspType: "",
  inspectedBy: null,
  inspectedByName: null,
  inspectionId: "",
  modDate: null,
  qaDate: null,
  qcDate: null,
  rbm: null,
  scopeNote: null,
  startDate: "",
  teamHelper: null,
  teamLeader: "",
};
export default INSPECTION_TYPE;
